import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSystemAvatar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 20,
			fill: "#DFDFDF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			opacity: .05,
			x: .5,
			y: .5,
			width: 39,
			height: 39,
			rx: 19.5,
			stroke: "#111"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11 11.5h18V24h-8v2.5h4v2H15v-2h4V24h-8V11.5zm2 2V22h14v-8.5H13z",
			fill: "#111"
		})
	]
});
export default SvgSystemAvatar;
